// No test coverage: module-level SDK client initialization with no testable logic
import * as prismic from '@prismicio/client';
import { Client } from '@prismicio/client';

import { getPrismicAccessToken, getPrismicRepo } from '@/utils/env-utils.ts';

export const client: Client = prismic.createClient(getPrismicRepo(), {
    accessToken: getPrismicAccessToken(),
});
